import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    IAPIResponse,
    ITeam,
    ITournament,
    ITournamentList,
    IUser,
} from "../../types/api";
import { alertActions } from "../alert/alertSlice";
import {
    getClubhouseTeams,
    getClubhouseTournaments,
    getTournament as getTournamentFromAPI,
} from "../../lib/api";

interface IGetTournamentsResponse extends IAPIResponse {
    tournaments: ITournamentList[];
}

interface IGetLeagueResponse extends IAPIResponse {
    tournament: ITournament;
}

interface IGetTeamsResponse extends IAPIResponse {
    teams: ITeam[];
}

export const getTournaments = createAsyncThunk<
    IGetTournamentsResponse,
    IUser["id"],
    { rejectValue: string }
>("clubhouse/getTournaments", async (userId, { rejectWithValue, dispatch }) => {
    try {
        const response = await getClubhouseTournaments(userId);

        return response;
    } catch (e) {
        const error = e as string;
        // dispatch(
        //     alertActions.error({
        //         level: "danger",
        //         text: "Team retrieval failed. Please try again later or contact an admin",
        //         title: error,
        //     }),
        // );
        return rejectWithValue(error);
    }
});

export const getTeams = createAsyncThunk<
    IGetTeamsResponse,
    { userId: IUser["id"]; isRegistering?: boolean },
    { rejectValue: string }
>(
    "clubhouse/getTeams",
    async (
        { userId, isRegistering = false },
        { rejectWithValue, dispatch },
    ) => {
        try {
            const response = await getClubhouseTeams(userId, isRegistering);

            return response;
        } catch (e) {
            const error = e as string;
            // dispatch(
            //     alertActions.error({
            //         level: "danger",
            //         text: "Team retrieval failed. Please try again later or contact an admin",
            //         title: error,
            //     }),
            // );
            return rejectWithValue(error);
        }
    },
);

export const getLeague = createAsyncThunk<
    IGetLeagueResponse,
    ITournament["id"],
    { rejectValue: string }
>(
    "clubhouse/getLeague",
    async (tournamentId, { rejectWithValue, dispatch }) => {
        try {
            const response = await getTournamentFromAPI(tournamentId);

            return response;
        } catch (e) {
            const error = e as string;
            // dispatch(
            //     alertActions.error({
            //         level: "danger",
            //         text: "League retrieval failed. Please try again later or contact an admin",
            //         title: error,
            //     }),
            // );
            return rejectWithValue(error);
        }
    },
);
